import React from 'react'

import { IconProps } from '../Types'

export const GroupOutline = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps = {}) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="GroupOutline"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path fill-rule="evenodd" d="m12.31,8.25c0,2.07-1.68,3.75-3.75,3.75s-3.75-1.68-3.75-3.75,1.68-3.75,3.75-3.75,3.75,1.68,3.75,3.75Zm-1.88,0c0-1.03-.84-1.87-1.88-1.87s-1.88.84-1.88,1.87.84,1.87,1.88,1.87,1.88-.84,1.88-1.87Z"/><path d="m2.03,18.33c.71-2.96,3.31-5.03,6.34-5.03s5.64,2.07,6.34,5.03c.12.5-.17,1.01-.65,1.14-.07.02-.15.03-.22.03-.4,0-.76-.28-.86-.71-.51-2.12-2.41-3.61-4.62-3.61s-4.11,1.48-4.62,3.61c-.12.5-.6.81-1.08.68-.48-.13-.77-.64-.65-1.14Z"/><path fill-rule="evenodd" d="m16.69,12c1.78,0,3.23-1.44,3.23-3.23s-1.45-3.23-3.23-3.23-3.23,1.45-3.23,3.23,1.45,3.23,3.23,3.23Zm0-4.84c.89,0,1.61.73,1.61,1.61s-.73,1.61-1.61,1.61-1.62-.73-1.62-1.61.73-1.61,1.62-1.61Z"/><path d="m21.98,17.46s0,0,0,0c.02.11.03.22,0,.32,0,0,0,0,0,.01-.02.12-.07.23-.14.32-.15.19-.37.31-.6.31h-.12c-.29-.05-.54-.27-.62-.59-.44-1.83-2.07-3.11-3.98-3.11-.82,0-1.57.25-2.22.66-.32-.43-.67-.84-1.07-1.19.09-.07.19-.13.29-.19.03-.02.06-.04.09-.06.09-.06.19-.12.29-.17.1-.05.21-.1.32-.14.03-.01.07-.03.1-.04.04-.02.08-.04.12-.05.09-.04.18-.08.28-.11.14-.05.28-.08.42-.11.03,0,.06-.01.1-.02.04-.01.08-.02.12-.03.08-.02.16-.04.24-.06.28-.05.57-.07.86-.07.01,0,.02,0,.03,0,.01,0,.02,0,.04,0,.28,0,.55.03.81.07,2.25.33,4.1,1.98,4.65,4.26,0,0,0,0,0,.01Z"/>',
    }}
  />
)

GroupOutline.displayName = 'GroupOutline'

export const tags = ['GroupOutline', '']
